import React, { Component, useEffect } from 'react';
import {
  Redirect,
  Router,
  Switch,
  Route,
  useLocation
} from "react-router-dom";

function ScrollToTop() {
  const location = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [location.key]);
  return null;
}
import browserHistory from '../history';
import * as config from '../config';
import { connect } from 'react-redux';
import { getWebsiteDefault, getLocation } from '../redux/reducers/reducer';
import LandingPage from './authentication/LandingPage';
import { UserProvider } from './userContext';
import AddDevice from "./authentication/AddDevice";
import CreateAnAccount from './authentication/CreateAnAccount';
import ActivationCode from './authentication/ActivationCode';
import Activate from './authentication/Activate';
import AccountSettings from './authentication/account-settings';
import AlertPopup from './AlertPopup';
import SuccessBought from './scheduler/SuccessBought';
import Loader from './Loader';
import SubscriptionPayment from './authentication/SubscriptionPayment';
import Terms from './authentication/Terms';
import Privacy from './authentication/Privacy';
import About from './authentication/About';
import Contactus from './authentication/Contactus';
import Plans from './authentication/Plans';
import Profile from './authentication/Profile';
import Scheduler from './scheduler/index';
// import AutoPlayChannel from './scheduler/AutoPlayChannel';
import AutoPlayChannel from './scheduler/bitmovinPlayer';
import OnDemand from './scheduler/OnDemand';
import AssetInfoPage from './scheduler/AssetInfoPage';
import buyAsset from './scheduler/buyAsset';
import GiftPayment from './scheduler/GiftPayment';
import subscriptionPayment from './scheduler/subscriptionPayment';
import Movies from './scheduler/Movies';
import Search from './scheduler/Search';
import Shows from './scheduler/Shows';
import Series from './scheduler/Series';
import Player from './scheduler/Player';
import contactSuccess from './authentication/contactSuccess';
import SubscriptionPlans from './SubscriptionPlans';
import UnderConstruction from './authentication/UnderConstruction';
import Careers from './authentication/Careers';
import Advertise from './authentication/Advertise';
import Partners from './authentication/Partners';
import CreatorPage from './scheduler/CreatorPage';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoaded: false,
      status: localStorage.getItem('status'),
    }
  }
  componentDidMount() {
    this.props.getWebsiteDefault();
  }
  async componentDidUpdate(prevProps) {
    let nextProps = this.props
    if (nextProps.websiteDefaultData !== prevProps.websiteDefaultData) {
      let siteConfig = window.site.config || {};
      let imageSuffix = siteConfig.imageSuffix;
      let imagePrefix = siteConfig.imagePrefix
      this.setState({ imagePrefix, imageSuffix, siteConfig, isLoaded: true })
      this.props.getLocation()
    }
  }
  render() {
    const { imagePrefix, siteConfig, isLoaded, status } = this.state;
    const baseHref = config.BASE_HREF;
    return (isLoaded ?
      <div className="App full-width full-height envoi-scheduler channel-guide">
        <UserProvider value={{ imagePrefix, siteConfig }}>
          <Router history={browserHistory}>
            <ScrollToTop />
            <Switch>
              <Route path="/create" component={CreateAnAccount} />
              <Route path='/adddevice' component={AddDevice} />
              <Route path="/activation" component={ActivationCode} />
              <Route path="/activate" component={Activate} />
              <Route path="/account" component={AccountSettings} />
              <Route path="/boughtsuccess" component={SuccessBought} />
              {/* <Route path="/subpayment/:planId" component={SubscriptionPayment} /> */}
              <Route path="/subscriptionpayment" component={subscriptionPayment} />
              <Route path="/buyAsset" component={buyAsset} />
              <Route path="/giftedPayment" component={GiftPayment} />
              <Route path="/terms" component={Terms} />
              <Route path="/about" component={About} />
              <Route path="/privacy" component={Privacy} />
              <Route path="/contactUs" component={Contactus} />
              <Route path="/plans" component={Plans} />
              <Route path="/profile" component={Profile} />
              <Route path="/pricing" component={SubscriptionPlans} />
              <Route path="/scheduler" component={Scheduler} />
              <Route path="/onDemand" component={OnDemand} />
              <Route path="/asset" component={AssetInfoPage} />
              <Route path="/search" component={Search} />
              <Route path="/movies" component={Movies} />
              <Route path="/shows" component={Shows} />
              <Route path="/series" component={Series} />
              <Route path="/podcasts" component={Movies} />
              <Route path="/musicvideos" component={Movies} />
              <Route path="/interviews" component={Movies} />
              <Route path="/commercials" component={Movies} />
              <Route path="/player" component={Player} />
              <Route path="/success" component={contactSuccess} />
              <Route path="/careers" component={Careers} />
              <Route path="/help" component={UnderConstruction} />
              <Route path="/devices" component={UnderConstruction} />
              <Route path="/accessibility" component={UnderConstruction} />
              <Route path="/advertise" component={Advertise} />
              <Route path="/partners" component={Partners} />
              <Route path="/creator" component={CreatorPage} />
              <Route path="/ios" component={UnderConstruction} />
              <Route path="/android" component={UnderConstruction} />
              <Route path="/roku" component={UnderConstruction} />
              <Route path="/amazon" component={UnderConstruction} />
              <Route path="/press" component={UnderConstruction} />
              <Route path="/news" component={UnderConstruction} />
              <Route path="/privacy-choices" component={UnderConstruction} />
              <Route path="/cookies" component={UnderConstruction} />
              {/* <Route path={`${baseHref}`}>
                <OnDemand
                /> */}
                 <Route path={`${baseHref}`}>
                <AutoPlayChannel
                />
              </Route>
            </Switch>
          </Router>
        </UserProvider>
        <AlertPopup />
      </div> : <Loader />
    );
  }
}

const mapState = ({ websiteDefaultData }) => ({ websiteDefaultData });
const mapDispatch = { getWebsiteDefault, getLocation };
export default connect(mapState, mapDispatch)(App);

